export default __webpack_public_path__ + "static/media/inactive.a438552d.svg";